import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { useNavigate } from 'react-router-dom';
import StepProgressiveBar from '@components/molecule/auth/stepProgressiveBar';

const Welcome = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector(({ auth }: RootState) => auth);

  const onClickStart = useCallback(() => {
    alert('Coming Soon!');
  }, []);

  const onClickSkip = useCallback(() => {
    navigate('/manager/service/appManager', { replace: true });
  }, [navigate, userInfo]);

  return (
    <>
      {userInfo ? (
        <div className="other-layout join">
          <div className="main-content">
            <header className="header">
              <div className="header-inner">
                <h1 className="header-logo">
                  <img src="/images/logo-axo-app.png" alt="axo" />
                </h1>

                <label className="select type-1">
                  <select>
                    <option>ENG</option>
                    <option>JP</option>
                    <option>KOR</option>
                  </select>
                </label>
              </div>
            </header>
            <div className="container">
              <div>
                <div className="manager">
                  <div>
                    <StepProgressiveBar step="step3" />
                  </div>
                  <h2 className="manager-tit">Welcome to ASO Index!</h2>
                  <p className="manager-dsc">
                    {userInfo.userName}! Thank you for joining ASO Index! <br />
                    Think with us & Grow with us!
                  </p>
                </div>

                <p className="join-email-user">
                  <span>{userInfo.email}</span>
                </p>

                {/* start Tutorial 아직 안되어있음.. */}
                <div className="join-btn-create">
                  <button type="button" className="btn-b pri" onClick={onClickStart}>
                    Start Tutorial
                  </button>
                </div>

                {/* skip Tutorial */}
                <div className="join-btn-create">
                  <button type="button" className="btn-b pri" onClick={onClickSkip}>
                    Skip Tutorial
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        'loading...'
      )}
    </>
  );
};

export default Welcome;
